import React, { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, notification } from 'antd';

import { updateBookingLineGuestThoiHanLuuTru } from 'services/api/module/customer.api';

type Props = {
  guestId: number;
  value?: string;
  onUpdated?: () => void;
};

function TemporaryResidenceDateCell({ guestId, value, onUpdated }: Props) {
  const [loading, setLoading] = useState(false);

  const handleChange = async (date: Dayjs | null) => {
    setLoading(true);
    try {
      await updateBookingLineGuestThoiHanLuuTru(guestId, date ? date.format('YYYY-MM-DD') : null);
      onUpdated?.();
      notification.success({ message: 'Đã cập nhật Thời hạn lưu trú' });
    } catch (err: any) {
      notification.error({ message: err?.error || 'Cập nhật thất bại' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DatePicker
      format="DD/MM/YYYY"
      value={value ? dayjs(value) : null}
      onChange={handleChange}
      disabled={loading}
      allowClear
      style={{ width: '100%' }}
    />
  );
}

export default TemporaryResidenceDateCell;
